export default {
  color: 'black-tint-80',
  size: '16px',
  border: {
    width: '1px',
    color: {
      dark: 'black-tint-80',
      light: 'black-tint-80'
    }
  },
  hover: {
    border: {
      color: {
        dark: 'black-tint-60',
        light: 'black-tint-60'
      }
    }
  }
}
